// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"fV-z"};